<div class="l-bottom-float">
  <div class="p-bottom-float-navi01 p-bottom-float-navi01--2col">
    <div class="p-bottom-float-navi01__wrap">
      <div class="p-bottom-float-navi01__inner">
        <div class="p-bottom-float-navi01__item"></div>
        <div class="p-bottom-float-navi01__item">
          <asw-button
            id="plan-review-pres-component-open-select-next-page-modal-btn"
            (click$)="openSelectNextPageModal()"
            throttleClick
            [disabled]="!isAbleToGoToNextPage"
            [label]="'label.prebookAndContinue' | staticMsg"
          ></asw-button>
        </div>
      </div>
    </div>
  </div>
  <!--
/=====================================================
[#1]
* Required javascript behavior:
画面内に[画面下部固定フローティングナビ]を配置する際には
javascriptにてdiv.l-bottom-floatの高さを取得し、
取得した値 + 8pxをdiv.l-containerのpadding-bottom値として設定してください
=====================================================/
-->
  <!-- //[画面下部固定フローティングナビ] -->
</div>
